window.customElements.define('page-mobilenav', class extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('click', (e) => {
      const $currentSub = e.target.nextElementSibling;
      if ($currentSub && $currentSub.classList.contains('mobilenav__list')) {
        e.preventDefault();
        $currentSub.classList.toggle('is-active');
      }
    });

    this.$return = this.querySelectorAll('.mobilenav__list__return');
    this.$return.forEach(($return) => {
      $return.addEventListener('click', (e) => {
        const $list = e.currentTarget.parentNode;
        $list.classList.toggle('is-active');
        e.preventDefault();
      });
    });

    this.$trigger = this.querySelector('.mobilenav__trigger');

    this.$trigger.addEventListener('click', () => {
      this.toggle();
    });
  }

  get active() {
    return this.getAttribute('active');
  }

  set active(value) {
    if (value) {
      this.setAttribute('active', value);
    } else {
      this.removeAttribute('active');
    }
  }

  toggle() {
    this.active = this.active ? '' : 'true';
  }
});
